import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Hide cursor on mobile devices
const hideCursorOnMobile = () => {
  if (window.innerWidth <= 768) {
    // Add CSS to hide cursor
    const style = document.createElement('style');
    style.textContent = `
      * {
        cursor: none !important;
        -webkit-touch-callout: none !important;
        -webkit-user-select: none !important;
        -webkit-tap-highlight-color: transparent !important;
      }
      
      *:hover, *:active, *:focus {
        cursor: none !important;
      }
      
      html, body {
        cursor: none !important;
      }
    `;
    document.head.appendChild(style);
    
    // Also hide cursor via JavaScript
    document.addEventListener('mousemove', () => {
      document.body.style.cursor = 'none';
    });
    
    document.addEventListener('touchstart', () => {
      document.body.style.cursor = 'none';
    });
  }
};

// Run on load
hideCursorOnMobile();

// Run on resize
window.addEventListener('resize', hideCursorOnMobile);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
); 